// eslint-disable-next-line import/no-cycle
import { getEquipTree } from '@/api/equipments/equipments';

const state = {
  projectList: null,
  projectListTree: null,
  selectProject: null,
  selectProjectChild: null,
};

const mutations = {
  // eslint-disable-next-line no-shadow
  PROJECT_LIST: (state, projectList) => {
    state.projectList = projectList;
  },
  PROJECT_LIST_TREE: (state, projectListTree) => {
    state.projectListTree = projectListTree;
  },
  SET_SELECT_PROJECT: (state, selectProject) => {
    state.selectProject = selectProject;
  },
  SET_SELECT_PROJECT_CHILD: (state, selectProjectChild) => {
    state.selectProjectChild = selectProjectChild;
  },
};

const actions = {
  projectList({ commit }) {
    return getEquipTree({}).then((res) => {
      commit('PROJECT_LIST', res);
      if (res.length > 0) {
        commit('SET_SELECT_PROJECT', res[0].IdStr); // 选择的项目 默认第一条
      }
    });
  },
  projectListTree({ commit }) {
    // type: 1
    return getEquipTree({}).then((res) => {
      commit('PROJECT_LIST_TREE', res);
    });
  },
  setSelectProject({ commit }, val) {
    commit('SET_SELECT_PROJECT', val);
  },
  setSelectProjectChild({ commit }, val) {
    commit('SET_SELECT_PROJECT_CHILD', val);
  },
};
export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
